<template>
  <div class="smart_display">
    <StudySmartHomeComponent msg="空間知能化のお勉強"/>
  </div>
</template>

<script>
// @ is an alias to /src
import StudySmartHomeComponent from '@/components/StudySmartHomeComponent.vue'

export default {
  name: 'StudySmartHome',
  components: {
    StudySmartHomeComponent
  }
}
</script>
